import React from 'react';

import './style.scss';

import { T } from '../../../constants';
import { useTranslation } from '../../../hooks';

interface ComingSoonProps {

}

export const ComingSoon: React.FC<ComingSoonProps> = () => {
  const t = useTranslation();
  return (
    <>
      <div className="coming-soon-container">
        <div className="coming-soon-wrapper">
          <h1 className="coming-soon-text">{t(T.COMING_SOON)}</h1>
          <div className="accent-line"></div>
        </div>
      </div>
    </>
  );
};
